import { render, staticRenderFns } from "./createContactInformation.vue?vue&type=template&id=249770aa"
import script from "./createContactInformation.vue?vue&type=script&lang=ts"
export * from "./createContactInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports